import { render, staticRenderFns } from "./GuidedModeQuestion.vue?vue&type=template&id=05b54320"
import script from "./GuidedModeQuestion.vue?vue&type=script&lang=ts"
export * from "./GuidedModeQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports